"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkColumnStyle = checkColumnStyle;
exports.checkColumnType = checkColumnType;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ykbUtils = require("ykb-utils");
var _Button = _interopRequireDefault(require("../Button"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Iban = _interopRequireDefault(require("../Iban"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SearchFilter = require("./filterComponents/SearchFilter");
var _SearchableDropDown = require("./filterComponents/SearchableDropDown");
var _DateFilter = require("./filterComponents/DateFilter");
var _NumberFilter = require("./filterComponents/NumberFilter");
var _CurrencyFilter = require("./filterComponents/CurrencyFilter");
var _TimeFilter = require("./filterComponents/TimeFilter");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TYPE_FORMAT_MAP = {
  DATE: 'DD-MM-YYYY',
  DATETIME: 'DD-MM-YYYY HH:mm:ss',
  JSONDATE: 'DD-MM-YYYY HH:mm:ss',
  TIMESTAMP: 'DD-MM-YYYY HH:mm:ss',
  TIME: 'HH:mm:ss'
};

// action handler
var actionHandler = function actionHandler(_ref) {
  var contentRenderer = _ref.contentRenderer,
    typeDefination = _ref.type,
    locale = _ref.locale,
    onInputFocus = _ref.onInputFocus,
    dataIndex = _ref.dataIndex,
    theme = _ref.theme,
    size = _ref.size;
  return function (value, row, index) {
    var classes = {
      hiddenStatus: false
    };
    var type = _objectSpread({}, typeDefination);
    if (type.hidden) {
      if (typeof type.hidden === 'function') classes.hiddenStatus = type.hidden(row);else if (typeof type.hidden === 'boolean') classes.hiddenStatus = type.hidden;
    }
    var cls = (0, _classnames.default)("table-action-button", (0, _defineProperty2.default)({
      hidden: classes.hiddenStatus
    }, "editable-cell-".concat(row.key, "-").concat(dataIndex, "-").concat(type.action), true));
    if (!type.buttonProps) {
      type.buttonProps = {};
    }
    if (type.disabled && typeof type.disabled === 'function') {
      type.disabled = type.disabled(row);
    }
    if (type.disabled === true) {
      type.buttonProps.disabled = true;
    }
    if (type.action === 'edit') {
      // we have editable table we can check if record is editing with this function
      var isEditing = false;
      if (typeof type.isEditing === 'function') {
        isEditing = type.isEditing(row);
      }
      if (isEditing) {
        return type.render(value, row, index);
      }
    }
    return !classes.hiddenStatus && /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
      type: "ghost",
      size: "small",
      className: cls,
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (type.handler) {
          type.handler(row, e, index);
        }
      },
      tabIndex: "0"
    }, type.buttonProps, {
      onFocus: function onFocus(e) {
        type.buttonProps.onFocus && type.buttonProps.onFocus(e);
        onInputFocus(row, "".concat(dataIndex, "-").concat(type.action));
      }
    }), contentRenderer(value, row, index, locale, type, theme, size));
  };
};

// column types
var columnTypes = {
  currency: function currency(_ref2) {
    var currencyType = _ref2.currencyType,
      currencyPrecision = _ref2.currencyPrecision,
      allowEmpty = _ref2.allowEmpty,
      removeTrailingZeros = _ref2.removeTrailingZeros;
    return function (value, record) {
      var _currencyType = typeof currencyType == "function" ? currencyType(record) : currencyType;
      var __value = _ykbUtils.excelExportFormatter.currency({
        value: value,
        currencyType: _currencyType,
        currencyPrecision: currencyPrecision,
        allowEmpty: allowEmpty,
        removeTrailingZeros: removeTrailingZeros
      });
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-currency-field"
      }, __value);
    };
  },
  number: function number() {
    return function (value) {
      var __value = _ykbUtils.excelExportFormatter.number(value);
      if ((0, _ykbUtils.isNullOrUndefined)(__value)) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-table-number-field"
      }, __value, " ");
    };
  },
  iban: function iban() {
    return function (value) {
      if (value && value.length === 26) {
        return /*#__PURE__*/_react.default.createElement(_Iban.default, {
          value: value
        });
      } else {
        return value;
      }
    };
  },
  moment: function moment(_ref3) {
    var format = _ref3.format;
    return function (value) {
      var date = _ykbUtils.excelExportFormatter.date(value, format);
      if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-table-date-field"
      }, date);
    };
  },
  date: function date(_ref4) {
    var format = _ref4.format;
    return function (value) {
      var date = _ykbUtils.excelExportFormatter.date(value, format);
      if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-table-date-field"
      }, date);
    };
  },
  datetime: function datetime(_ref5) {
    var format = _ref5.format;
    return function (value) {
      var date = _ykbUtils.excelExportFormatter.date(value, format);
      if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-table-date-time-field"
      }, date);
    };
  },
  jsondate: function jsondate(_ref6) {
    var format = _ref6.format;
    return function (value) {
      var date = _ykbUtils.excelExportFormatter.jsondate(value, format);
      if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-table-date-time-field"
      }, date);
    };
  },
  timestamp: function timestamp(_ref7) {
    var format = _ref7.format;
    return function (value) {
      var date = _ykbUtils.excelExportFormatter.timestamp(value, format);
      if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-table-date-time-field"
      }, date);
    };
  },
  time: function time(_ref8) {
    var format = _ref8.format;
    return function (value) {
      var date = _ykbUtils.excelExportFormatter.time(value, format);
      if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ykb-table-date-time-field"
      }, date, " ");
    };
  },
  edit: function edit(value, row, index, locale, type, theme, size) {
    var _theme$table, _theme$table$action$s, _theme$table2, _theme$table2$action;
    var tooltipProps = type.tooltipProps || {};
    if (type.disabled === true || type.buttonProps && type.buttonProps.disabled) {
      tooltipProps.visible = false;
    }
    var iconSize = (theme === null || theme === void 0 ? void 0 : (_theme$table = theme.table) === null || _theme$table === void 0 ? void 0 : (_theme$table$action$s = _theme$table.action[size]) === null || _theme$table$action$s === void 0 ? void 0 : _theme$table$action$s.iconSize) || (theme === null || theme === void 0 ? void 0 : (_theme$table2 = theme.table) === null || _theme$table2 === void 0 ? void 0 : (_theme$table2$action = _theme$table2.action) === null || _theme$table2$action === void 0 ? void 0 : _theme$table2$action.iconSize) || 24;
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
      placement: "top",
      overlay: type.title || locale.edit
    }, tooltipProps), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "edit",
      colorType: "primary",
      size: iconSize
    })));
  },
  detail: function detail(value, row, index, locale, type, theme, size) {
    var _theme$table3, _theme$table3$action$, _theme$table4, _theme$table4$action;
    var tooltipProps = type.tooltipProps || {};
    if (type.disabled || type.buttonProps && type.buttonProps.disabled) {
      tooltipProps.visible = false;
    }
    var iconSize = (theme === null || theme === void 0 ? void 0 : (_theme$table3 = theme.table) === null || _theme$table3 === void 0 ? void 0 : (_theme$table3$action$ = _theme$table3.action[size]) === null || _theme$table3$action$ === void 0 ? void 0 : _theme$table3$action$.iconSize) || (theme === null || theme === void 0 ? void 0 : (_theme$table4 = theme.table) === null || _theme$table4 === void 0 ? void 0 : (_theme$table4$action = _theme$table4.action) === null || _theme$table4$action === void 0 ? void 0 : _theme$table4$action.iconSize) || 24;
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
      placement: "top",
      overlay: type.title || locale.detail
    }, tooltipProps), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "search",
      colorType: "primary",
      size: iconSize
    })));
  },
  delete: function _delete(value, row, index, locale, type, theme, size) {
    var _theme$table5, _theme$table5$action$, _theme$table6, _theme$table6$action;
    var tooltipProps = type.tooltipProps || {};
    if (type.disabled || type.buttonProps && type.buttonProps.disabled) {
      tooltipProps.visible = false;
    }
    var iconSize = (theme === null || theme === void 0 ? void 0 : (_theme$table5 = theme.table) === null || _theme$table5 === void 0 ? void 0 : (_theme$table5$action$ = _theme$table5.action[size]) === null || _theme$table5$action$ === void 0 ? void 0 : _theme$table5$action$.iconSize) || (theme === null || theme === void 0 ? void 0 : (_theme$table6 = theme.table) === null || _theme$table6 === void 0 ? void 0 : (_theme$table6$action = _theme$table6.action) === null || _theme$table6$action === void 0 ? void 0 : _theme$table6$action.iconSize) || 24;
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
      placement: "top",
      overlay: type.title || locale.delete
    }, tooltipProps), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "trash",
      colorType: "default",
      size: iconSize
    })));
  },
  custom: function custom(value, row, index, locale, type, theme, size) {
    var _type$iconProps, _type$iconProps2, _type$iconProps3, _theme$table7, _theme$table7$action$, _theme$table8, _theme$table8$action, _type$buttonProps;
    var iconProps = (type === null || type === void 0 ? void 0 : type.iconProps) || {};
    var tooltipProps = (type === null || type === void 0 ? void 0 : type.tooltipProps) || {};
    var isExistRenderIcon = type === null || type === void 0 ? void 0 : type.renderIcon;
    var renderIcon = isExistRenderIcon && (type === null || type === void 0 ? void 0 : type.renderIcon(row));
    var colorType = typeof (type === null || type === void 0 ? void 0 : (_type$iconProps = type.iconProps) === null || _type$iconProps === void 0 ? void 0 : _type$iconProps.colorType) == 'function' ? type === null || type === void 0 ? void 0 : (_type$iconProps2 = type.iconProps) === null || _type$iconProps2 === void 0 ? void 0 : _type$iconProps2.colorType(row) : (type === null || type === void 0 ? void 0 : (_type$iconProps3 = type.iconProps) === null || _type$iconProps3 === void 0 ? void 0 : _type$iconProps3.colorType) || 'default';
    var iconSize = (theme === null || theme === void 0 ? void 0 : (_theme$table7 = theme.table) === null || _theme$table7 === void 0 ? void 0 : (_theme$table7$action$ = _theme$table7.action[size]) === null || _theme$table7$action$ === void 0 ? void 0 : _theme$table7$action$.iconSize) || (theme === null || theme === void 0 ? void 0 : (_theme$table8 = theme.table) === null || _theme$table8 === void 0 ? void 0 : (_theme$table8$action = _theme$table8.action) === null || _theme$table8$action === void 0 ? void 0 : _theme$table8$action.iconSize) || 24;
    var icon = renderIcon || /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
      colorType: colorType,
      size: iconSize
    }, iconProps));
    if (type !== null && type !== void 0 && type.disabled || type !== null && type !== void 0 && (_type$buttonProps = type.buttonProps) !== null && _type$buttonProps !== void 0 && _type$buttonProps.disabled) {
      tooltipProps.visible = false;
    }
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
      placement: "top",
      overlay: type.title || tooltipProps.title || ''
    }, tooltipProps), /*#__PURE__*/_react.default.createElement("div", null, icon));
  }
};
function checkColumnType(columnData, locale) {
  var onInputFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var theme = arguments.length > 3 ? arguments[3] : undefined;
  var size = arguments.length > 4 ? arguments[4] : undefined;
  var column = _objectSpread({}, columnData);

  // after rc-table@7.x "data.prop" usage deprecated to support old style we need to process dataIndex prop.
  // now nested dataIndex represented as ['data', 'prop'] array.
  if (column.dataIndex && !Array.isArray(column.dataIndex) && column.dataIndex.includes('.')) {
    column.dataIndex = column.dataIndex.split('.');
  }
  if (column.type && (columnTypes[column.type] || column.type.action && columnTypes[column.type.action])) {
    var _theme$table9, _theme$table9$action$, _theme$table10, _theme$table10$action;
    var columnWidth = (theme === null || theme === void 0 ? void 0 : (_theme$table9 = theme.table) === null || _theme$table9 === void 0 ? void 0 : (_theme$table9$action$ = _theme$table9.action[size]) === null || _theme$table9$action$ === void 0 ? void 0 : _theme$table9$action$.width) || (theme === null || theme === void 0 ? void 0 : (_theme$table10 = theme.table) === null || _theme$table10 === void 0 ? void 0 : (_theme$table10$action = _theme$table10.action) === null || _theme$table10$action === void 0 ? void 0 : _theme$table10$action.width) || '44px';
    if ((0, _typeof2.default)(column.type) === 'object') {
      column.width = column.width || columnWidth; //iconSize + paddingHorizontal * 2
      column.fixed = 'right';
      var actionColumnTitleProps = {
        type: column.type,
        theme: theme,
        size: size
      };
      column.title = getActionColumnTitle(actionColumnTitleProps);
      column.align = 'center';
      column.render = actionHandler(_objectSpread(_objectSpread({}, column), {}, {
        locale: locale,
        contentRenderer: columnTypes[column.type.action],
        onInputFocus: onInputFocus,
        theme: theme,
        size: size
      }));
    } else {
      if (typeof column.render !== 'function') column.render = columnTypes[column.type](_objectSpread({}, column));
    }
  }
  if (column.autoFilter === true) {
    var autoFilterProps = column.autoFilterProps || {};
    if (column.autoFilterType === 'search' || column.type === 'iban' && !column.autoFilterType) {
      column.filterDropdown = function (props) {
        return /*#__PURE__*/_react.default.createElement(_SearchFilter.SearchFilter, (0, _extends2.default)({}, props, {
          locale: locale
        }, autoFilterProps));
      };
      if (!column.onFilter) {
        column.onFilter = function (v, record) {
          return (0, _SearchFilter.onSearchFilter)(column.dataIndex, v, record);
        };
      }
    } else if (column.type === 'date' || column.type === 'datetime' || column.type === 'jsondate' || column.type === 'timestamp' || column.autoFilterType === 'datetime') {
      var format = column.format ? column.format : TYPE_FORMAT_MAP[column.type.toUpperCase()];
      column.filterDropdown = function (props) {
        return /*#__PURE__*/_react.default.createElement(_DateFilter.DateFilter, (0, _extends2.default)({}, props, {
          locale: locale,
          format: format
        }, autoFilterProps));
      };
      if (!column.onFilter) {
        column.onFilter = function (v, record) {
          return (0, _DateFilter.onDateFilter)({
            dataIndex: column.dataIndex,
            type: column.type,
            format: format
          }, v, record);
        };
      }
    } else if (column.type === 'time' || column.autoFilterType === 'time') {
      var _format = TYPE_FORMAT_MAP[column.type.toUpperCase()];
      column.filterDropdown = function (props) {
        return /*#__PURE__*/_react.default.createElement(_TimeFilter.TimeFilter, (0, _extends2.default)({}, props, {
          locale: locale,
          format: _format
        }, autoFilterProps));
      };
      if (!column.onFilter) {
        column.onFilter = function (v, record) {
          return (0, _TimeFilter.onTimeFilter)(column.dataIndex, v, record, _format);
        };
      }
    } else if (column.type === 'number' || column.autoFilterType === 'number') {
      column.filterDropdown = function (props) {
        return /*#__PURE__*/_react.default.createElement(_NumberFilter.NumberFilter, (0, _extends2.default)({
          dataIndex: column.dataIndex
        }, props, {
          locale: locale
        }, autoFilterProps));
      };
      if (!column.onFilter) {
        column.onFilter = function (v, record) {
          return (0, _NumberFilter.onNumberFilter)(column.dataIndex, v, record);
        };
      }
    } else if (column.type === 'currency' || column.autoFilterType === 'currency') {
      column.filterDropdown = function (props) {
        var _currencyType = typeof column.currencyType == "function" ? column.currencyType() : column.currencyType;
        return /*#__PURE__*/_react.default.createElement(_CurrencyFilter.CurrencyFilter, (0, _extends2.default)({
          dataIndex: column.dataIndex,
          currencyType: _currencyType,
          currencyPrecision: column.currencyPrecision
        }, props, {
          locale: locale
        }, autoFilterProps));
      };
      if (!column.onFilter) {
        column.onFilter = function (v, record) {
          return (0, _CurrencyFilter.onCurrencyFilter)(column.dataIndex, v, record);
        };
      }
    } else {
      column.filterDropdown = function (props) {
        return /*#__PURE__*/_react.default.createElement(_SearchableDropDown.SearchableDropDown, (0, _extends2.default)({}, props, {
          filters: column.filters,
          multiple: !!column.multiple,
          dataIndex: column.dataIndex,
          locale: locale,
          render: column.render
        }, autoFilterProps));
      };
      if (!column.onFilter) {
        column.onFilter = function (v, record) {
          return (0, _SearchableDropDown.onDropDownFilter)(column.dataIndex, v, record);
        };
      }
    }
  }
  return column;
}
function checkColumnStyle(columnData) {
  var column = _objectSpread({}, columnData);
  if (column.cellStyle) {
    var oldOnCell = column.onCell;
    var result = {};
    column.onCell = function (record, rowIndex) {
      if (oldOnCell) result = oldOnCell(record, rowIndex);
      result.rowIndex = rowIndex;
      var classNameString = [typeof column.cellStyle === 'function' ? column.cellStyle(record, rowIndex) : column.cellStyle, result['className']].join(' ');
      return _objectSpread(_objectSpread({}, result), {}, {
        className: classNameString
      });
    };
  }
  return column;
}
function getActionColumnTitle(actionColumnTitleProps) {
  var type = actionColumnTitleProps.type;
  var actionColTitleFn = actionColumnTitleTypes[type.action] || actionColumnTitleTypes.default;
  return actionColTitleFn(actionColumnTitleProps) || actionColumnTitleTypes.default();
}
var actionColumnTitleTypes = {
  custom: function custom(_ref9) {
    var type = _ref9.type,
      theme = _ref9.theme,
      size = _ref9.size;
    if (type.titleProps && (0, _typeof2.default)(type.titleProps) === 'object') {
      var titleProps = type.titleProps;
      return actionTitleActionHandler({
        titleProps: titleProps,
        theme: theme,
        size: size
      });
    }
  },
  default: function _default() {
    return '';
  }
};
var actionTitleActionHandler = function actionTitleActionHandler(_ref10) {
  var _ref10$titleProps = _ref10.titleProps,
    titleProps = _ref10$titleProps === void 0 ? {} : _ref10$titleProps,
    theme = _ref10.theme,
    size = _ref10.size;
  var _titleProps$type = titleProps.type,
    type = _titleProps$type === void 0 ? 'custom' : _titleProps$type,
    handler = titleProps.handler,
    disabled = titleProps.disabled,
    _titleProps$buttonPro = titleProps.buttonProps,
    buttonProps = _titleProps$buttonPro === void 0 ? {} : _titleProps$buttonPro;
  var className = (0, _classnames.default)("table-action-button");
  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
    type: "ghost",
    size: "small",
    className: className,
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      if (handler) {
        handler(e);
      }
    },
    disabled: disabled,
    tabIndex: "0"
  }), actionColumnActionTitleTypes[type]({
    titleProps: titleProps,
    theme: theme,
    size: size
  }));
};
var actionColumnActionTitleTypes = {
  custom: function custom(_ref11) {
    var _theme$table11, _theme$table11$action, _theme$table12, _theme$table12$action;
    var _ref11$titleProps = _ref11.titleProps,
      titleProps = _ref11$titleProps === void 0 ? {} : _ref11$titleProps,
      theme = _ref11.theme,
      size = _ref11.size;
    var _titleProps$iconProps = titleProps.iconProps,
      iconProps = _titleProps$iconProps === void 0 ? {} : _titleProps$iconProps,
      _titleProps$tooltipPr = titleProps.tooltipProps,
      tooltipProps = _titleProps$tooltipPr === void 0 ? {} : _titleProps$tooltipPr;
    var iconSize = (theme === null || theme === void 0 ? void 0 : (_theme$table11 = theme.table) === null || _theme$table11 === void 0 ? void 0 : (_theme$table11$action = _theme$table11.action[size]) === null || _theme$table11$action === void 0 ? void 0 : _theme$table11$action.iconSize) || (theme === null || theme === void 0 ? void 0 : (_theme$table12 = theme.table) === null || _theme$table12 === void 0 ? void 0 : (_theme$table12$action = _theme$table12.action) === null || _theme$table12$action === void 0 ? void 0 : _theme$table12$action.iconSize) || 24;
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({}, tooltipProps, {
      placement: "top",
      overlay: (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || ''
    }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, iconProps, {
      size: iconSize
    }))));
  }
};